import React from "react";
import { Forward10, Pause, Play, Replay10 } from "@yleisradio/yds-icons-react";
import styled, { css } from "styled-components";

import { useEmbedParametersContext } from "../../contexts/embedParametersContext";
import i18n from "../../service/i18n";
import { usePlayerStore } from "../../store/usePlayerStore";
import { ControlBarButton } from "../../styles/commonStyles";

const Controls = styled.div`
  align-items: center;
  display: flex;
  height: 100%;
  justify-content: center;
  pointer-events: none;
  position: absolute;
  width: 100%;
  z-index: 1;
`;

const MobileButtonStyle = css`
  background-color: rgb(0 0 0 / 79%);
  border-radius: 50%;
`;

const SeekButton = styled(ControlBarButton)`
  height: 40px;
  width: 40px;
  ${MobileButtonStyle}
`;

const PlayButton = styled(ControlBarButton)`
  height: 56px;
  width: 56px;
  margin: 0 16px;
  ${MobileButtonStyle}
`;

export const MobileOverlayControls = () => {
  const { useStoreState } = usePlayerStore();
  const isControlsVisible = useStoreState.isControlsVisible();
  const isDraggingTimeline = useStoreState.isDraggingTimeline();
  const isEnded = useStoreState.isEnded();
  const isPaused = useStoreState.isPaused();
  const player = useStoreState.player();

  const { language, replayButton } = useEmbedParametersContext();

  const replayButtonVisible = replayButton && isEnded;
  const showControls =
    isControlsVisible && !isDraggingTimeline && !replayButtonVisible;

  return (
    showControls && (
      <Controls>
        <SeekButton
          aria-label={i18n("kelaa_10s_taaksepain", { language })}
          onClick={() => player.seekFor(-10)}>
          <Replay10 width={20} />
        </SeekButton>
        <PlayButton
          aria-label={i18n(
            isPaused ? "toista_aria_label" : "keskeyta_aria_label",
            {
              language
            }
          )}
          onClick={() => (isPaused ? player.play() : player.pause())}>
          {isPaused ? <Play /> : <Pause />}
        </PlayButton>
        <SeekButton
          aria-label={i18n("kelaa_10s_eteenpain", { language })}
          onClick={() => player.seekFor(10)}>
          <Forward10 width={20} />
        </SeekButton>
      </Controls>
    )
  );
};
